import { graphqlRequest } from '../api/index.js'

const STATION_QUERY = `
  query Station($accountName: String!, $stationName: String!) {
    station(accountName: $accountName, stationName: $stationName) {
      id
      name
      CurrentClienteNormal
      CurrentClientePreferencial
      filaPreferencial
      filaNormal
    }
  }
`

const CREATE_ACCOUNT_MUTATION = `
  mutation CreateAccount($email: String!, $name: String!) {
    createAccount(email: $email, name: $name) {
      id
      email
      name
    }
  }
`

const CREATE_STATION_MUTATION = `
  mutation CreateStation($_idacc: ID!, $name: String!) {
    createStation(_idacc: $_idacc, name: $name) {
      id
      name
      CurrentClienteNormal
      CurrentClientePreferencial
      filaPreferencial
      filaNormal
    }
  }
`

const UPDATE_STATION_MUTATION = `
  mutation UpdateStation(
    $id: ID!
    $CurrentClienteNormal: Int
    $CurrentClientePreferencial: Int
    $filaPreferencial: Int
    $filaNormal: Int
  ) {
    updateStation(
      id: $id
      CurrentClienteNormal: $CurrentClienteNormal
      CurrentClientePreferencial: $CurrentClientePreferencial
      filaPreferencial: $filaPreferencial
      filaNormal: $filaNormal
    ) {
      id
      name
      CurrentClienteNormal
      CurrentClientePreferencial
      filaPreferencial
      filaNormal
    }
  }
`

async function updateStation ({ commit, state }, fields) {
  const data = await graphqlRequest(UPDATE_STATION_MUTATION, {
    id: state.station.id,
    ...fields
  })
  commit('SET_STATION', data.updateStation)
}

export default {
  async createAccount ({ commit }, { email, name }) {
    const data = await graphqlRequest(CREATE_ACCOUNT_MUTATION, { email, name })
    commit('SET_ACCOUNT', data.createAccount)
    return data.createAccount
  },
  async createStation ({ commit }, { accountId, name }) {
    const data = await graphqlRequest(CREATE_STATION_MUTATION, { _idacc: accountId, name })
    commit('SET_STATION', data.createStation)
    return data.createStation
  },
  async fetchStation ({ commit }, { accountName, stationName }) {
    const data = await graphqlRequest(STATION_QUERY, { accountName, stationName })
    commit('SET_STATION', data.station)
  },
  incrementCurrentClienteNormal ({ state, commit }) {
    if (state.station.CurrentClienteNormal >= state.station.filaNormal) {
      return
    }
    return updateStation({ commit, state }, { CurrentClienteNormal: state.station.CurrentClienteNormal + 1 })
  },
  incrementCurrentClientePreferencial ({ state, commit }) {
    if (state.station.CurrentClientePreferencial >= state.station.filaPreferencial) {
      return
    }
    return updateStation({ commit, state }, { CurrentClientePreferencial: state.station.CurrentClientePreferencial + 1 })
  },
  incrementFilaNormal ({ state, commit }) {
    return updateStation({ commit, state }, { filaNormal: state.station.filaNormal + 1 })
  },
  incrementFilaPreferencial ({ state, commit }) {
    return updateStation({ commit, state }, { filaPreferencial: state.station.filaPreferencial + 1 })
  }
}
